module.exports = __webpack_public_path__ + "img/bianjie.82e0910b.png";